import { useEffect, useState } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useUserPreferenceTypes = () => {
  const [userPreferenceTypes, setUserPreferenceTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    async function fetchData() {
      setLoading(true)
      setError(null)

      try {
        const { data, error: fetchError } = await supabaseGetter.userPreferenceTypes.getAll()

        if (!isMounted) return

        if (fetchError) {
          console.warn('Error fetching user preference types:', fetchError)
          setError(fetchError.message || 'Failed to fetch user preference types')
          setUserPreferenceTypes([])
        } else if (data) {
          setUserPreferenceTypes(data)
        }
      } catch (err) {
        if (!isMounted) return
        
        console.error('Error fetching user preference types data:', err);
        setError(err.message);
        setUserPreferenceTypes([])
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchData()
    return () => { isMounted = false }
  }, [])

  return {
    userPreferenceTypes,
    loading,
    error,
    invalidate: supabaseGetter.userPreferenceTypes.invalidate
  }
}
